import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-67b3fcfb"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "d-flex flex-column justify-content-between gap-3 h-100" }
const _hoisted_2 = {
  class: "ps-0 p-2",
  style: {"overflow":"auto"}
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h6", { class: "p-3 text-center card bg-light-danger text-danger" }, "Escolha a ordem de exibiçao no cardápio", -1))
const _hoisted_4 = ["onDragstart", "onDragover", "onDrop"]
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "d-flex flex-row align-items-center col-3" }, [
  /*#__PURE__*/_createElementVNode("svg", {
    width: "20",
    height: "20",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512"
  }, [
    /*#__PURE__*/_createElementVNode("path", { d: "M0 96C0 78.3 14.3 64 32 64H416c17.7 0 32 14.3 32 32s-14.3 32-32 32H32C14.3 128 0 113.7 0 96zM0 256c0-17.7 14.3-32 32-32H416c17.7 0 32 14.3 32 32s-14.3 32-32 32H32c-17.7 0-32-14.3-32-32zM448 416c0 17.7-14.3 32-32 32H32c-17.7 0-32-14.3-32-32s14.3-32 32-32H416c17.7 0 32 14.3 32 32z" })
  ])
], -1))
const _hoisted_6 = { class: "col-6" }
const _hoisted_7 = { class: "d-flex flex-row gap-4 align-items-center justify-content-end col-3" }
const _hoisted_8 = {
  key: 0,
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  viewBox: "0 0 576 512"
}
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("path", {
  d: "M316.9 18C311.6 7 300.4 0 288.1 0s-23.4 7-28.8 18L195 150.3 51.4 171.5c-12 1.8-22 10.2-25.7 21.7s-.7 24.2 7.9 32.7L137.8 329 113.2 474.7c-2 12 3 24.2 12.9 31.3s23 8 33.8 2.3l128.3-68.5 128.3 68.5c10.8 5.7 23.9 4.9 33.8-2.3s14.9-19.3 12.9-31.3L438.5 329 542.7 225.9c8.6-8.5 11.7-21.2 7.9-32.7s-13.7-19.9-25.7-21.7L381.2 150.3 316.9 18z",
  fill: "gold"
}, null, -1))
const _hoisted_10 = [
  _hoisted_9
]
const _hoisted_11 = {
  key: 1,
  class: "d-none"
}
const _hoisted_12 = {
  id: "paiBtn",
  class: "d-flex flex-row w-100 justify-content-end"
}
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fs-6 fa-save" }, null, -1))
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Salvar", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Button = _resolveComponent("Button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("ul", _hoisted_2, [
      _hoisted_3,
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.listaProdutos, (item, index) => {
        return (_openBlock(), _createElementBlock("li", {
          class: _normalizeClass(["d-flex justify-content-between", { dragging: index === _ctx.draggingItem }]),
          key: index,
          ref_for: true,
          ref: "listItem",
          draggable: "true",
          onDragstart: ($event: any) => ($setup.dragStart(index, $event)),
          onDragend: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => ($setup.dragEnd && $setup.dragEnd(...args))),
          onDragover: ($event: any) => ($setup.dragOver(index, $event)),
          onDrop: ($event: any) => ($setup.drop(index, $event)),
          style: {"transition":"opacity 0.3s ease","outline":"none !important","background":"white","position":"relative"}
        }, [
          _hoisted_5,
          _createElementVNode("span", _hoisted_6, _toDisplayString(item.servico), 1),
          _createElementVNode("div", _hoisted_7, [
            (index === 0)
              ? (_openBlock(), _createElementBlock("svg", _hoisted_8, _hoisted_10))
              : (_openBlock(), _createElementBlock("div", _hoisted_11))
          ])
        ], 42, _hoisted_4))
      }), 128))
    ]),
    _createElementVNode("div", _hoisted_12, [
      _createVNode(_component_Button, {
        variant: "primary",
        onClick: $setup.enviarOrdemAtualizadaPai,
        class: "btn btn-sm btn-danger p-2 d-flex flex-row gap-2 align-items-center",
        type: "submit"
      }, {
        default: _withCtx(() => [
          _hoisted_13,
          _hoisted_14
        ]),
        _: 1
      }, 8, ["onClick"])
    ])
  ]))
}